import {useEffect, useState} from "react";
import {ProjectCard} from "./ProjectCard";

// Add project IDs here to hide them from the portfolio
const HIDDEN_PROJECT_IDS = [
    19, 23, 24, 26, 29, 30, 31
];

export function ProjectList({type = "projects", filter}) {
    const [items, setItems] = useState([]);
    const [page, setPage] = useState(1);
    const [cardsPerPage, setCardsPerPage] = useState(6);

    // Adjust cards per page based on screen width
    useEffect(() => {
        const updateCardsPerPage = () => {
            if (window.innerWidth < 768) {
                setCardsPerPage(3); // Mobile
            } else {
                setCardsPerPage(6); // Tablet & Desktop
            }
        };

        updateCardsPerPage(); // run on mount
        window.addEventListener("resize", updateCardsPerPage);

        return () => window.removeEventListener("resize", updateCardsPerPage);
    }, []);

    useEffect(() => {
        fetch("/api/api.php")
            .then((res) => res.json())
            .then((data) => {
                const key = type === "stage" ? "internships" : type;

                if (data.data[key]) {
                    let filteredItems = data.data[key];

                    if (filter && type === "projects") {
                        if (filter === "technova") {
                            filteredItems = data.data[key].filter(item => {
                                const yearNr = parseInt(item['year_nr']);
                                return yearNr >= 1 && yearNr <= 4;
                            });
                        } else if (filter === "hu") {
                            filteredItems = data.data[key].filter(item => {
                                const yearNr = parseInt(item['year_nr']);
                                return yearNr >= 5 && yearNr <= 8;
                            });
                        } else {
                            filteredItems = data.data[key].filter(item => {
                                const yearNr = parseInt(item['year_nr']);
                                return yearNr === 0 || item['year_nr'] === "0";
                            });
                        }
                    }
                    if (HIDDEN_PROJECT_IDS.length > 0) {
                        filteredItems = filteredItems.filter(
                            item => !HIDDEN_PROJECT_IDS.includes(Number(item.id))
                        );
                    }
                    setItems(filteredItems);
                }
            })
            .catch((err) => console.error(err));
    }, [type, filter]);

    const totalPages = Math.ceil(items.length / cardsPerPage);
    const displayedData = items.slice((page - 1) * cardsPerPage, page * cardsPerPage);

    const nextPage = () => {
        if (page < totalPages) setPage((prev) => prev + 1);
    };

    const prevPage = () => {
        if (page > 1) setPage((prev) => prev - 1);
    };

    return (
        <>
            {displayedData.map((item) => (
                <ProjectCard
                    key={item.id}
                    type={type}
                    year_nr={item.year_nr}
                    semester_nr={item.semester_nr}
                    filter={filter}
                    title={item.name || item.company}
                    code={item.code}
                    shortDescription={item.description}
                    description={item.details}
                    imgUrl={
                        item.images?.[0]?.image_url.replace(/\\/g, "/") ||
                        item.link?.replace(/\\/g, "/") ||
                        "files/img/placeholder.jpeg"
                    }
                    images={item.images || []}
                />
            ))}

            {/* Pagination controls */}
            {totalPages > 0 && (
                <div className="col-span-full w-full flex justify-center items-center mt-8 space-x-4 text-white">
                    {page > 1 && (
                        <button
                            onClick={prevPage}
                            className="text-2xl transition-colors"
                            style={{color: 'white'}}
                            aria-label="Previous page"
                        >
                            &#8592;
                        </button>
                    )}
                    <span className="mx-3 text-base">{`Pagina ${page} van ${totalPages}`}</span>
                    {page < totalPages && (
                        <button
                            onClick={nextPage}
                            className="text-2xl transition-colors"
                            style={{color: 'white'}}
                            aria-label="Next page"
                        >
                            &#8594;
                        </button>
                    )}
                </div>
            )}
        </>
    );
}
